import React from "react";

export const Gutter = ({
    height
}) => <div style={{height}}></div>